/* content file: replace all html between <> </> with actual content */

export const OpenCode = () => { 
  return (
  <>
    <p className="mb-4">
      Open CoDE ist die gemeinsame Plattform der Öffentlichen Verwaltung für den Austausch von Open Source Software: 
      <a 
        target="_blank" 
        rel="noreferrer" 
        className="text-primary-plain-Color hover:underline mx-1" 
        href='https://gitlab.opencode.de/ga-lotse'
      >
        openCode
      </a>. 
      Sie sind herzlich eingeladen, sich die quelloffenen Software GA-Lotse anzuschauen.</p>
  </>    
  )
}